import type { ComponentType, SVGProps } from 'react'
import styles from './CountryFlags.module.css'

/** Spain: red-yellow-red (yellow band double width) */
function FlagES(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="España" className={styles.flagSvg} {...props}>
      <rect width="24" height="4" fill="#C60B1E" />
      <rect y="4" width="24" height="8" fill="#FFC400" />
      <rect y="12" width="24" height="4" fill="#C60B1E" />
    </svg>
  )
}

/** UK: simplified Union Jack */
function FlagGB(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Reino Unido" className={styles.flagSvg} {...props}>
      <rect width="24" height="16" fill="#012169" />
      <path d="M0 0l24 16M24 0L0 16" stroke="#fff" strokeWidth="3" />
      <path d="M0 0l24 16M24 0L0 16" stroke="#C8102E" strokeWidth="2" />
      <path d="M12 0v16M0 8h24" stroke="#fff" strokeWidth="5" />
      <path d="M12 0v16M0 8h24" stroke="#C8102E" strokeWidth="3" />
    </svg>
  )
}

/** USA: simplified (blue canton + stripes) */
function FlagUS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Estados Unidos" className={styles.flagSvg} {...props}>
      <rect width="24" height="16" fill="#B22234" />
      <rect y="0" width="24" height="1.23" fill="#fff" />
      <rect y="2.46" width="24" height="1.23" fill="#fff" />
      <rect y="4.92" width="24" height="1.23" fill="#fff" />
      <rect y="7.38" width="24" height="1.23" fill="#fff" />
      <rect y="9.84" width="24" height="1.23" fill="#fff" />
      <rect y="12.3" width="24" height="1.23" fill="#fff" />
      <rect y="14.77" width="24" height="1.23" fill="#fff" />
      <rect width="10" height="8" fill="#3C3B6E" />
      <circle cx="2" cy="1.5" r="0.35" fill="#fff" />
      <circle cx="5" cy="1.5" r="0.35" fill="#fff" />
      <circle cx="8" cy="1.5" r="0.35" fill="#fff" />
      <circle cx="3.5" cy="3" r="0.35" fill="#fff" />
      <circle cx="6.5" cy="3" r="0.35" fill="#fff" />
      <circle cx="2" cy="4.5" r="0.35" fill="#fff" />
      <circle cx="5" cy="4.5" r="0.35" fill="#fff" />
      <circle cx="8" cy="4.5" r="0.35" fill="#fff" />
      <circle cx="3.5" cy="6" r="0.35" fill="#fff" />
      <circle cx="6.5" cy="6" r="0.35" fill="#fff" />
    </svg>
  )
}

const FLAG_COMPONENTS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  ES: FlagES,
  UK: FlagGB,
  GB: FlagGB,
  USA: FlagUS,
  US: FlagUS,
}

interface CountryFlagsProps {
  codes: string[]
}

export function CountryFlags({ codes }: CountryFlagsProps) {
  return (
    <span className={styles.flags} aria-hidden>
      {codes.map((code) => {
        const Flag = FLAG_COMPONENTS[code]
        const title = code === 'ES' ? 'España' : code === 'UK' || code === 'GB' ? 'Reino Unido' : 'Estados Unidos'
        if (!Flag) return null
        return (
          <span key={code} className={styles.flagWrap} title={title}>
            <Flag />
          </span>
        )
      })}
    </span>
  )
}
